import SeasonService from '@/services/SeasonService.js'

export const namespaced = true

export const state = {
  calendarDates: [],
  seasons: [], // Innehåller också deleted_at seasons
  isFetchingSeasons: false,
  triggerReloadSeasonBookings: 0
}

export const mutations = {
  SET_CALENDAR_DATES (state, val) {
    state.calendarDates = val
  },
  SET_SEASONS (state, val) {
    state.seasons = val
  },
  ADD_OR_REPLACE_SEASON (state, val) {
    const index = state.seasons.findIndex(season => season.id === val.id)
    if (index !== -1) {
      // Ersätt befintlig säsong
      state.seasons.splice(index, 1, val)
    } else {
      // Lägg till ny säsong
      state.seasons.push(val)
    }
  },
  SET_IS_FETCHING_SEASONS (state, val) {
    state.isFetchingSeasons = val
  },
  TRIGGER_RELOAD_SEASON_BOOKINGS (state) {
    state.triggerReloadSeasonBookings++
  }
}

export const actions = {
  replaceSeasons ({ commit, dispatch }, seasons) {
    commit('SET_SEASONS', seasons) // Ersätter seasons i state
    dispatch('booking/enrichBookings', { seasonBookingsOnly: true }, { root: true }) // Berikar om samtliga säsongsbokningar lokalt, eftersom de har koppling till seasons
  },
  fetchCalendarDates ({ commit }) {
    // Datum till bokningskalendern
    // Skapar tillfälliga datum innan hämtat datum från server
    const startDate = window.dayjs.today().subtract(1, 'year').startOf('year').startOf('week')
    const endDate = window.dayjs.today().add(1, 'year').endOf('year').endOf('week')
    let iteratedDate = startDate.clone()
    const datesArray = []
    let i = 0
    while (iteratedDate.isBefore(endDate)) {
      datesArray.push({
        index: i++,
        date: iteratedDate,
        isToday: false,
        isPast: false,
        isHoliday: false,
        isWeekend: false
      })
      iteratedDate = iteratedDate.add(1, 'day')
    }
    commit('SET_CALENDAR_DATES', datesArray)

    return SeasonService.getCalendarDates()
      .then(({ data }) => {
        data.data.calendar_dates.forEach(dateObject => {
          dateObject.date = window.dayjs.parseServerDate(dateObject.date)
        })
        commit('SET_CALENDAR_DATES', data.data.calendar_dates)
      })
  },
  fetchSeasons ({ commit, dispatch }) {
    commit('SET_IS_FETCHING_SEASONS', true)
    return SeasonService.getSeasons()
      .then(({ data }) => {
        window.enrich.enrichSeason(data.data.seasons)
        commit('SET_SEASONS', data.data.seasons)
      })
      .finally(() => {
        commit('SET_IS_FETCHING_SEASONS', false)
        window.channel.stopListening('SeasonSaved').listen('SeasonSaved', function (data) {
          const season = data.season
          window.enrich.enrichSeason(season)
          commit('ADD_OR_REPLACE_SEASON', season)
          dispatch('booking/enrichBookings', { seasonBookingsOnly: true }, { root: true }) // Berikar om samtliga säsongsbokningar lokalt, eftersom de har koppling till seasons
        })
      })
  }
}

export const getters = {
  activeSeasons: function (state) {
    if (state.seasons.length === 0) {
      return []
    }
    const seasons = state.seasons.filter(season => {
      return season.deleted_at === null
    })
    return seasons
  }
}
